import React from 'react';
import ReactDOM from 'react-dom';
import './app/index.css';
import "./font/Gentona Thin.otf";
import "./font/Gentona Book.otf";
import "./font/Gentona Semi Bold.otf";
import Root from './app/Root';
import * as serviceWorker from './app/serviceWorker';
import { LicenseManager } from "ag-grid-enterprise";

LicenseManager.setLicenseKey(
    "Avenir_Health__MultiApp_1Devs8_November_2019__MTU3MzE3MTIwMDAwMA==5fe24a203ae4d849fe9768ee0a3219f5"
);

ReactDOM.render(<Root />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
